import { Directive, ElementRef, Input } from "@angular/core";
import { fromEvent, take } from "rxjs";

@Directive({
  selector: '[rotate]',
  standalone: true
})
export class RotateDirective {
  @Input() set rotate(value: string) {
    this.rotateElement(Number(value));
  }

  @Input() invert = false;

  constructor(private el: ElementRef) {}

  private calculateRotatedDimensions(width: number, height: number, rotationDegrees: number): { width: number; height: number } {
    const rotationRad = (rotationDegrees * Math.PI) / 180;
    const newWidth = Math.abs(width * Math.cos(rotationRad)) + Math.abs(height * Math.sin(rotationRad));
    const newHeight = Math.abs(height * Math.cos(rotationRad)) + Math.abs(width * Math.sin(rotationRad));
    
    return { width: newWidth, height: newHeight };
  }

  rotateElement(rotateDegrees: number) {
    if (this.el.nativeElement instanceof HTMLImageElement) {
      fromEvent(this.el.nativeElement, 'load').pipe(
        take(1)
      ).subscribe(() => {
        this.rotateImage(this.el.nativeElement, rotateDegrees);
      });
    } else {
      this.rotateImage(this.el.nativeElement, rotateDegrees);
    }
  }

  private rotateImage(el: HTMLElement, rotation: number) {
    if (rotation === 0) {
      el.style.transform = '';
      el.style.height = '';
      return;
    }

    const width = el.clientWidth;
    const height = el.clientHeight;
    const { 
      height: newHeight
    } = this.calculateRotatedDimensions(width, height, rotation);

    el.style.transform = `rotate(${this.invert ? rotation * -1 : rotation}deg)`;
    // Update height to fit the rotated image (parent container will need to be resized)
    el.style.height = `${newHeight}px`;
  }
}
